import { Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import styled from '@emotion/styled';

const StyledTableHead = styled(TableHead)`
  position: sticky;
  top: 0;
  z-index: 2;
  background: #ECF0F4;
`;

const StyledTableRowHeader = styled(TableRow)`
  background: #ECF0F4;
`;

const WorkOrderTableSkeleton = () => {
  return (
    <TableContainer component={Paper} sx={{ marginTop: '32px', borderRadius: 0 }}>
      <Table aria-label="work orders table loading skeleton">
        <StyledTableHead>
          <StyledTableRowHeader>
            <TableCell sx={{ textAlign: 'center' }}>Status</TableCell>
            <TableCell>Work Order</TableCell>
            <TableCell>ERP ID</TableCell>
            <TableCell>Customer Order</TableCell>
            <TableCell>Customer</TableCell>
            <TableCell>Branch</TableCell>
            <TableCell>Payment</TableCell>
            <TableCell>Delivery</TableCell>
            <TableCell>Note</TableCell>
          </StyledTableRowHeader>
        </StyledTableHead>
        <TableBody>
          {Array.from(new Array(5)).map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <Skeleton variant="rounded" width={100} height={32} animation="wave" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={120} animation="wave" />
                <Skeleton variant="text" width={80} animation="wave" sx={{ opacity: 0.5 }} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={100} animation="wave" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={130} animation="wave" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={150} animation="wave" />
                <Skeleton variant="text" width={100} animation="wave" sx={{ opacity: 0.5 }} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={120} animation="wave" />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={110} animation="wave" />
                <Skeleton variant="text" width={80} animation="wave" sx={{ opacity: 0.5 }} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={130} animation="wave" />
                <Skeleton variant="text" width={90} animation="wave" sx={{ opacity: 0.5 }} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width={100} animation="wave" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WorkOrderTableSkeleton; 